import React from "react";

const SectionHeader = ({ title, subtitle }) => {
  return (
    <div className="row">
      <div className="col-12">
        <h2 className="section-title" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
          {title}
        </h2>

        {subtitle && (
          <p className="section-subtitle" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
